export const mapTypes = [
  'alphaMap',
  'aoMap',
  'bumpMap',
  'displacementMap',
  'emissiveMap',    
  'lightMap',
  'map',
  'metalnessMap',
  'normalMap',
  'roughnessMap',
  'envMap',
  'customMap',
];

export const materialPropertyTypes = [
  ...mapTypes,
  'color',
  'emissive',
  'colorWrite',
  'visible',
  'transparent',
  'depthWrite',
  'alphaTest',
  'refractionRatio',
  'bumpScale',
  'metalness',
  'roughness',
  'opacity',
  'envMapIntensity',
  'emissiveIntensity',
  'lightMapIntensity',
  'blending',
  'blendEquation',
  'blendSrc',
  'blendDst',
  'normalScale',
];